// extracted by mini-css-extract-plugin
module.exports = {"buttons":"EditMailerDetails_buttons__3Wi25"};